import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { CustomFormatItem } from "../../../docuclipper/DocuclipperTypes";
import {
  updateCustomFormatItemRedux,
  deleteCustomFormatItemRedux,
} from "../../../redux/reducers/CustomFormat";
type Props = {
  cfi: CustomFormatItem;
};
export const CustomFormatItemComp: React.FC<Props> = ({ cfi }) => {
  const dispatch = useDispatch();

  return (
    <div>
      <Row className="align-items-center mx-2">
        <div className="h4 mt-1">{`Column ${cfi.index + 1}`}</div>
        <Button
          variant="link"
          onClick={() => dispatch(deleteCustomFormatItemRedux(cfi))}
        >
          <FontAwesomeIcon icon="trash" />
          <span className="ml-2">Delete Column</span>
        </Button>
      </Row>
      <Form.Group controlId="exampleForm.ControlSelect1">
        {/* <Form.Label>
          <strong>Field</strong>
        </Form.Label> */}
        <Form.Control
          as="select"
          value={cfi.source}
          onChange={(e) =>
            dispatch(
              updateCustomFormatItemRedux({
                ...cfi,
                source: e.target.value as any,
              })
            )
          }
        >
          <option value="date">Date</option>
          <option value="date2">Date2</option>
          <option value="name">Description</option>
          <option value="amount">Amount</option>
          <option value="credit">Credit</option>
          <option value="debit">Debit</option>
          <option value="balance">Balance</option>
          <option value="checkNumber">Check Number</option>
          <option value="refNumber">Reference Number</option>
          <option value="account">Account</option>
          <option value="category">Category</option>
          <option value="fileName">File Name</option>
          <option value="pageNumber">Page Number</option>
          <option value="metadata">Metadata</option>
        </Form.Control>
      </Form.Group>
    </div>
  );
};
export default CustomFormatItemComp;
